module.exports = function() {
  return new Worker(__webpack_public_path__ + "c94872afbe4edd621fcd.worker.js");
};